'use client'

import { integerToMoney } from '@/app/lib/moneyHandler'
import { EuroSymbolOutlined as EuroIcon } from '@mui/icons-material'
import { ReactNode } from 'react'
import { UseRangeProps } from 'react-instantsearch'
import { RangeSlider, useRangeRefinementStatus } from './RangeSlider'
import { SearchRefinementAccordion } from './SearchRefinementAccordion'

type CustomRangeRefinementProps = UseRangeProps & {
  label?: ReactNode
  icon?: ReactNode
  defaultExpanded?: boolean
  formatLabel?: (value: number) => string | number
}

export function CustomRangeRefinement({
  icon,
  defaultExpanded = true,
  formatLabel = integerToMoney,
  ...rangeProps
}: CustomRangeRefinementProps) {
  const { label } = rangeProps
  const { canRefine, hasValidRange } = useRangeRefinementStatus(rangeProps)

  return (
    <SearchRefinementAccordion
      icon={icon || <EuroIcon className="text-[22px]" />}
      label={label || ''}
      defaultExpanded={defaultExpanded}
      disabled={!canRefine || !hasValidRange}
    >
      <RangeSlider
        {...rangeProps}
        formatLabel={formatLabel}
        className="px-0 pb-2 md:px-6"
      />
    </SearchRefinementAccordion>
  )
}
